var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('TemplateDocumentCard')],1),_c('v-col',{attrs:{"cols":"12","md":"8"}},[_c('UpgradeDocumentList')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }